import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DynamicStyles = () => {
    const location = useLocation();

    useEffect(() => {
        const linkElement = document.getElementById("elementor-style"); if (linkElement) {
       
          if (location.pathname === "/about_us") {
            linkElement.disabled = false;
            // Enable CSS on About Us page 
          } else {
            linkElement.disabled = true;
          }
        }
      }, [location.pathname]);

  return null;
};

export default DynamicStyles;
